<div
    class="circle"
    [ngStyle]="{ 'background-color': color }"
>
</div>